import Image from "next/image";
import Link from "next/link";

export const Logo = ({ color = "white" }: { color?: string }) => {
    return (
        <Link href="/">
            <div className="flex items-center gap-2">
                <Image src="/logos/Asset_10-removebg-preview.png" alt="Conceev Digital" 
                    width={180}
                    height={50} 
                    // className="h-20 w-full" will use incase the client needs the logo to be bigger
            
                />
            </div>
        </Link>
    );
};